import { AddUserPhoneNumberResponse, GetSelfSmsUserResponse } from '@eigtech/auth0-types'
import { queryOptions, useMutation, useQuery, useQueryClient } from '@eigtech/ui-shared-api'
import { auth0BasePath } from '../constants'
import { get, post } from '../instance'
import { userQueryKeys } from './constants'

const getUserSmsConnection = async () =>
  await get<GetSelfSmsUserResponse>(`${auth0BasePath}/self-sms-user`)

export const getUserSmsConnectionQueryOptions = () =>
  queryOptions({
    queryKey: userQueryKeys.smsUser(),
    queryFn: () => getUserSmsConnection(),
  })

export function useGetUserSmsConnection() {
  return useQuery(getUserSmsConnectionQueryOptions())
}

export function useInvalidateUserSmsConnection() {
  const queryClient = useQueryClient()

  return function invalidateUserSmsConnection() {
    queryClient.invalidateQueries({ queryKey: userQueryKeys.smsUser() })
  }
}

export const addPhoneNumber = async ({
  userId,
  phoneNumber,
}: {
  userId: string
  phoneNumber: string
}) => {
  const { json } = await post<AddUserPhoneNumberResponse>(
    `${auth0BasePath}/${userId}/add-phone-number`,
    {
      phoneNumber,
    }
  )
  return json
}

export const useAddPhoneNumber = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: addPhoneNumber,
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: userQueryKeys.smsUser() })
    },
  })
}
